import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalCadastrarPerfilComponent } from '../modal-cadastrar-perfil/modal-cadastrar-perfil.component';
import { PerfilService } from 'src/app/services/PerfilService/perfil.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissaoService } from 'src/app/services/PermissaoService/permissao.service';
import {
  IGetPermissao,
  IGetPermissaoList
} from 'src/app/services/PermissaoService/permissao.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { generateUUID } from 'src/app/core/generators/generateUUID';

interface IOptions {
  name?: string;
  value?: number;
}

@Component({
  selector: 'app-cadastro-parametrizacao-acessos',
  templateUrl: './cadastro-parametrizacao-acessos.component.html',
  styleUrls: ['./cadastro-parametrizacao-acessos.component.scss']
})
export class CadastroParametrizacaoAcessosComponent implements OnInit {
  guid: string = generateUUID();
  acessosColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Suspender/Ativar',
      key: 'FL_SPND',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_SPND')
    },
    {
      header: 'Deletar',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  acessosData = [
    { nome: 'Cadastro de Funcionários', FL_INCL: false, NU_TIPO_PERM: 1 },
    {
      nome: 'Listagem de Funcionários',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_SPND: false,
      FL_DELT: false,
      NU_TIPO_PERM: 2,
      PK_PERM: 0
    },
    {
      nome: 'Cadastro de Perfis',
      FL_INCL: false,
      NU_TIPO_PERM: 3,
      PK_PERM: 0
    },
    {
      nome: 'Listagem de Perfis',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_DELT: false,
      NU_TIPO_PERM: 4,
      PK_PERM: 0
    },
    {
      nome: 'Permissões de Acessos',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_SPND: false,
      FL_DELT: false,
      NU_TIPO_PERM: 5,
      PK_PERM: 0
    }
  ];

  agendamentoColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Suspender/Ativar',
      key: 'FL_SPND',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_SPND')
    },
    {
      header: 'Deletar',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  agendamentoData = [
    {
      nome: 'Listagem de Agendamentos',
      FL_CNST: false,
      FL_EXPT: false,
      NU_TIPO_PERM: 6,
      PK_PERM: 0
    }
  ];

  parametrizacaoColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Suspender/Ativar',
      key: 'FL_SPND',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_SPND')
    },
    {
      header: 'Deletar',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  parametrizacaoData = [
    {
      nome: 'Gerenciamento de Pátio',
      FL_CNST: false,
      FL_EDIT: false,
      NU_TIPO_PERM: 7,
      PK_PERM: 0
    },
    {
      nome: 'Serviços',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      NU_TIPO_PERM: 8,
      PK_PERM: 0
    },
    {
      nome: 'Tabela de Preços',
      FL_INCL: false,
      FL_CNST: false,
      FL_EXPT: false,
      FL_SPND: false,
      FL_DELT: false,
      NU_TIPO_PERM: 9,
      PK_PERM: 0
    },
    {
      nome: 'Parametrização de Fila',
      FL_CNST: false,
      FL_EDIT: false,
      NU_TIPO_PERM: 35,
      PK_PERM: 0
    }
  ];

  empresasColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    }
  ];

  empresasData = [
    {
      nome: 'Listagem de Empresas',
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      NU_TIPO_PERM: 10,
      PK_PERM: 0
    },
    {
      nome: 'Transferência de Frota entre Empresas',
      FL_INCL: false,
      FL_CNST: false,
      NU_TIPO_PERM: 85,
      PK_PERM: 0
    }
  ];

  gateDeEntradaColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    }
  ];

  gateDeEntradaData = [
    {
      nome: 'Cadastrar Entrada',
      FL_INCL: false,
      NU_TIPO_PERM: 11,
      PK_PERM: 0
    },
    {
      nome: 'Listagem Entrada',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_SPND: false,
      FL_DELT: false,
      NU_TIPO_PERM: 12,
      PK_PERM: 0
    }
  ];

  servicosColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Anexar/Excluir Fotos',
      key: 'FL_ANEX',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_ANEX')
    },
    {
      header: 'Cancelar serviço',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  servicosData = [
    {
      nome: 'Entrada de Serviços',
      FL_INCL: false,
      FL_ANEX: false,
      NU_TIPO_PERM: 13,
      PK_PERM: 0
    },
    {
      nome: 'Listagem de Serviços',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_IMPR: false,
      FL_DELT: false,
      NU_TIPO_PERM: 14,
      PK_PERM: 0
    }
  ];

  laudoHigienizacaoColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Anexar/Excluir Fotos',
      key: 'FL_ANEX',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_ANEX')
    }
  ];

  laudoHigienizacaoData = [
    {
      nome: 'Laudo de Higienização',
      FL_INCL: false,
      FL_ANEX: false,
      NU_TIPO_PERM: 15,
      PK_PERM: 0
    },
    {
      nome: 'Listagem de Laudo Higienização',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 16,
      PK_PERM: 0
    }
  ];

  tampasGradesPaletesColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    }
  ];

  tampasGradesPaletesData = [
    {
      nome: 'Entrada Tampa/Grade/Palete',
      FL_INCL: false,
      NU_TIPO_PERM: 17,
      PK_PERM: 0
    },
    {
      nome: 'Saída Tampa/Grade/Palete',
      FL_INCL: false,
      NU_TIPO_PERM: 18,
      PK_PERM: 0
    },
    {
      nome: 'Listagem Tampa/Grade/Palete',
      FL_INCL: false,
      FL_CNST: false,
      FL_EXPT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 19,
      PK_PERM: 0
    }
  ];

  engateColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Anexar Fotos',
      key: 'FL_ANEX',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_ANEX')
    }
  ];

  engateData = [
    {
      nome: 'Cadastrar Engate',
      FL_INCL: false,
      FL_ANEX: false,
      NU_TIPO_PERM: 20,
      PK_PERM: 0
    },
    {
      nome: 'Listagem Engate',
      FL_INCL: false,
      FL_CNST: false,
      FL_EXPT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 21,
      PK_PERM: 0
    }
  ];

  desengateColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Anexar Fotos',
      key: 'FL_ANEX',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_ANEX')
    }
  ];

  desengateData = [
    {
      nome: 'Cadastrar Desengate',
      FL_INCL: false,
      FL_ANEX: false,
      NU_TIPO_PERM: 22,
      PK_PERM: 0
    },
    {
      nome: 'Listagem Desengate',
      FL_INCL: false,
      FL_CNST: false,
      FL_EXPT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 23,
      PK_PERM: 0
    }
  ];

  gateSaidaColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Faturar Cliente',
      key: 'FL_FTRT_CLNT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_FTRT_CLNT')
    }
  ];

  gateSaidaData = [
    {
      nome: 'Cadastrar Saída',
      FL_INCL: false,
      FL_FTRT_CLNT: false,
      NU_TIPO_PERM: 24,
      PK_PERM: 0
    },
    {
      nome: 'Listagem Saídas',
      FL_INCL: false,
      FL_CNST: false,
      FL_EXPT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 25,
      PK_PERM: 0
    }
  ];

  caixaColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Imprimir',
      key: 'FL_IMPR',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_IMPR')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Cancelar venda',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  caixaData = [
    {
      nome: 'Sangria',
      FL_INCL: false,
      FL_EDIT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 26,
      PK_PERM: 0
    },
    {
      nome: 'Suprimento',
      FL_INCL: false,
      FL_EDIT: false,
      FL_IMPR: false,
      NU_TIPO_PERM: 27,
      PK_PERM: 0
    },
    {
      nome: 'Abertura/Fechamento de Caixa',
      FL_INCL: false,
      FL_CNST: false,
      NU_TIPO_PERM: 28,
      PK_PERM: 0
    },
    {
      nome: 'Caixa Pátio',
      FL_INCL: false,
      FL_CNST: false,
      NU_TIPO_PERM: 34,
      PK_PERM: 0
    },
    {
      nome: 'Caixa Limpeza',
      FL_INCL: false,
      FL_CNST: false,
      NU_TIPO_PERM: 33,
      PK_PERM: 0
    },
    {
      nome: 'Caixa Estoque',
      FL_INCL: false,
      FL_CNST: false,
      FL_DELT: false,
      NU_TIPO_PERM: 36,
      PK_PERM: 0
    }
  ];

  higienizacaoAgendadaColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    }
  ];

  higienizacaoAgendadaData = [
    {
      nome: 'Higienização Agendada',
      FL_INCL: false,
      FL_EDIT: false,
      FL_CNST: false,
      FL_EXPT: false,
      NU_TIPO_PERM: 29,
      PK_PERM: 0
    }
  ];

  logsColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    }
  ];

  logsData = [
    {
      nome: `Listagem LOG's`,
      FL_CNST: false,
      NU_TIPO_PERM: 30,
      PK_PERM: 0
    }
  ];

  motoristasExternoColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    }
  ];

  motoristasExternoData = [
    {
      nome: `Listagem de Motoristas Externo`,
      FL_CNST: false,
      NU_TIPO_PERM: 31,
      PK_PERM: 0
    }
  ];

  estoqueColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Incluir',
      key: 'FL_INCL',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_INCL')
    },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Editar',
      key: 'FL_EDIT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EDIT')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    },
    {
      header: 'Deletar',
      key: 'FL_DELT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_DELT')
    }
  ];

  estoqueData = [
    {
      nome: 'Estoque',
      FL_INCL: false,
      FL_CNST: false,
      FL_EDIT: false,
      FL_EXPT: false,
      FL_DELT: false,
      NU_TIPO_PERM: 37,
      PK_PERM: 0
    }
  ];

  relatoriosColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    },
    {
      header: 'Exportar Excel',
      key: 'FL_EXPT',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_EXPT')
    }
  ];

  relatoriosData = [
    { nome: 'Relatório Veículos', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 40, PK_PERM: 0 },
    { nome: 'Histórico por Veículo', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 41, PK_PERM: 0 },
    { nome: 'Laudos Editados', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 42, PK_PERM: 0 },
    { nome: 'Dashboard Serviços', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 43, PK_PERM: 0 },
    { nome: 'Dashboard Pátio', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 44, PK_PERM: 0 },
    { nome: 'Dashboard Financeiro', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 86, PK_PERM: 0 },
    { nome: 'Vendas por Produto', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 45, PK_PERM: 0 },
    { nome: 'Laudos Excluídos e Cancelados', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 46, PK_PERM: 0 },
    { nome: 'Relatório por Terminal', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 47, PK_PERM: 0 },
    { nome: 'Terminal (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 48, PK_PERM: 0 },
    { nome: 'Carregamento - Quantitativo (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 49, PK_PERM: 0 },
    { nome: 'Carregamento - Detalhado (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 50, PK_PERM: 0 },
    { nome: 'Cliente - Quantitativo (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 51, PK_PERM: 0 },
    { nome: 'Cliente - Detalhado (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 52, PK_PERM: 0 },
    { nome: 'Mensal (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 53, PK_PERM: 0 },
    { nome: 'Quantidade por Cliente (PDF)', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 54, PK_PERM: 0 },
    { nome: 'Placas - Caixa', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 55, PK_PERM: 0 },
    { nome: 'Vendas Estoque', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 79, PK_PERM: 0 },
    { nome: 'Relatório Vendas Estoque', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 57, PK_PERM: 0 },
    { nome: 'Relatório Movimentações Estoque', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 58, PK_PERM: 0 },
    { nome: 'Relatório Posição Estoque', FL_CNST: false, FL_EXPT: false, NU_TIPO_PERM: 59, PK_PERM: 0 }
  ];

  graficosColumns = [
    { header: '', key: 'nome', type: 'text' },
    {
      header: 'Consultar',
      key: 'FL_CNST',
      type: 'checkbox',
      action: (item: any) => this.addPermissao(item, 'FL_CNST')
    }
  ];

  graficosData = [
    { nome: 'Serviços — Limpezas no período', FL_CNST: false, NU_TIPO_PERM: 80, PK_PERM: 0 },
    { nome: 'Serviços — Agendamentos de limpeza', FL_CNST: false, NU_TIPO_PERM: 81, PK_PERM: 0 },
    { nome: 'Serviços — Média de caminhões/dia', FL_CNST: false, NU_TIPO_PERM: 82, PK_PERM: 0 },
    { nome: 'Serviços — Terminais ativos', FL_CNST: false, NU_TIPO_PERM: 83, PK_PERM: 0 },
    { nome: 'Serviços — Receita no período', FL_CNST: false, NU_TIPO_PERM: 84, PK_PERM: 0 },
    { nome: 'Serviços — Limpezas por mês', FL_CNST: false, NU_TIPO_PERM: 38, PK_PERM: 0 },
    { nome: 'Serviços — Limpezas por terminal', FL_CNST: false, NU_TIPO_PERM: 60, PK_PERM: 0 },
    { nome: 'Serviços — Limpezas por transportadora', FL_CNST: false, NU_TIPO_PERM: 61, PK_PERM: 0 },
    { nome: 'Serviços — Limpezas agendadas', FL_CNST: false, NU_TIPO_PERM: 62, PK_PERM: 0 },
    { nome: 'Serviços — Média mensal por serviço', FL_CNST: false, NU_TIPO_PERM: 63, PK_PERM: 0 },
    { nome: 'Serviços — Qtd vendas por tipo de serviço', FL_CNST: false, NU_TIPO_PERM: 64, PK_PERM: 0 },
    { nome: 'Serviços — Valor vendas por tipo de serviço', FL_CNST: false, NU_TIPO_PERM: 65, PK_PERM: 0 },
    { nome: 'Serviços — Distribuição forma de pagamento', FL_CNST: false, NU_TIPO_PERM: 66, PK_PERM: 0 },
    { nome: 'Serviços — Valores forma de pagamento', FL_CNST: false, NU_TIPO_PERM: 67, PK_PERM: 0 },
    { nome: 'Pátio — Total de veículos', FL_CNST: false, NU_TIPO_PERM: 39, PK_PERM: 0 },
    { nome: 'Pátio — Agendado por terminais', FL_CNST: false, NU_TIPO_PERM: 68, PK_PERM: 0 },
    { nome: 'Pátio — Total no pátio', FL_CNST: false, NU_TIPO_PERM: 69, PK_PERM: 0 },
    { nome: 'Pátio — Tempo de permanência', FL_CNST: false, NU_TIPO_PERM: 70, PK_PERM: 0 },
    { nome: 'Pátio — Diário total', FL_CNST: false, NU_TIPO_PERM: 71, PK_PERM: 0 },
    { nome: 'Pátio — Agendamentos D', FL_CNST: false, NU_TIPO_PERM: 72, PK_PERM: 0 },
    { nome: 'Pátio — Agendamentos D+1', FL_CNST: false, NU_TIPO_PERM: 73, PK_PERM: 0 },
    { nome: 'Pátio — Agendamentos D+2', FL_CNST: false, NU_TIPO_PERM: 74, PK_PERM: 0 },
    { nome: 'Pátio — Quantidade de estacionamento', FL_CNST: false, NU_TIPO_PERM: 75, PK_PERM: 0 },
    { nome: 'Pátio — Turnos e veículos', FL_CNST: false, NU_TIPO_PERM: 76, PK_PERM: 0 },
    { nome: 'Estoque — Indicadores', FL_CNST: false, NU_TIPO_PERM: 56, PK_PERM: 0 },
    { nome: 'Estoque — Últimas movimentações', FL_CNST: false, NU_TIPO_PERM: 77, PK_PERM: 0 },
    { nome: 'Estoque — Últimas vendas', FL_CNST: false, NU_TIPO_PERM: 78, PK_PERM: 0 }
  ];

  PermissoesList: any[] = [];

  form: FormGroup;
  perfisData: IOptions[] = [];
  isEditing: boolean = false;
  isBuscandoPermissoes: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private perfilService: PerfilService,
    private permissaoService: PermissaoService,
    private cd: ChangeDetectorRef,
    public dialog: MatDialog,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit() {
    this.getPerfis();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      PK_PERF: [null, Validators.required]
    });
    return form;
  }

  openCadastrarPerfil(edit?: boolean): void {
    const dialogConfig = new MatDialogConfig();

    const PK_PERF = this.form.controls['PK_PERF'].value;
    if (edit && !PK_PERF) return;

    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: PK_PERF,
      editing: edit
    };

    const dialogRef = this.dialog.open(
      ModalCadastrarPerfilComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      this.form.controls['PK_PERF'].setValue(null);
      this.getPerfis();
    });
  }

  deletePerfil(): void {
    const PK_PERF = this.form.controls['PK_PERF'].value;
    if (!PK_PERF) return;
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realmente excluir este perfil?',
      'warning',
      true,
      true,
      { confirmButtonText: 'Sim', cancelButtonText: 'Não' },
      () => {
        this.isLoading = true;
        this.perfilService.DeletePerfil(PK_PERF).subscribe({
          next: res => {
            this.getPerfis();
            this.form.controls['PK_PERF'].setValue(null);
            this.isLoading = false;
          },
          error: res => {
            this.isLoading = false;
          }
        });
        return;
      }
    );
  }

  savePerfil(): void {
    if (!this.isEditing) {
      this.createPermissoes();
    }
    if (this.isEditing) {
      this.updatePermissoes();
    }
  }

  createPermissoes(): void {
    const payload = { PermissoesList: this.PermissoesList };

    this.isLoading = true;
    this.permissaoService.CreatePermissoes(payload, this.guid).subscribe({
      next: res => {
        this.getPerfis();
        this.form.controls['PK_PERF'].setValue(null);
        this.cd.detectChanges();
        location.reload();
        this.isLoading = false;
      },
      error: res => {
        this.isLoading = false;
      }
    });
  }

  updatePermissoes(): void {
    const payload = { PermissoesList: this.PermissoesList };

    this.isLoading = true;
    this.permissaoService.UpdatePermissoes(payload).subscribe({
      next: res => {
        this.getPerfis();
        this.form.controls['PK_PERF'].setValue(null);
        this.cd.detectChanges();
        this.isLoading = false;
      },
      error: res => {
        this.isLoading = false;
      }
    });
  }

  addPermissao(item: any, permissao: any): void {
    const index = this.PermissoesList.findIndex(
      x =>
        x.NU_TIPO_PERM === item.NU_TIPO_PERM &&
        x.FK_PERF === Number(this.form.controls['PK_PERF'].value)
    );

    if (index === -1) {
      const novaPermissao: any = {
        PK_PERM: item.PK_PERM ?? 0,
        NU_TIPO_PERM: item.NU_TIPO_PERM,
        FL_INCL: item.FL_INCL || false,
        FL_CNST: item.FL_CNST || false,
        FL_EDIT: item.FL_EDIT || false,
        FL_EXPT: item.FL_EXPT || false,
        FL_SPND: item.FL_SPND || false,
        FL_DELT: item.FL_DELT || false,
        FL_IMPR: item.FL_IMPR || false,
        FL_ANEX: item.FL_ANEX || false,
        FL_FTRT_CLNT: item.FL_FTRT_CLNT || false,
        FK_PERF: Number(this.form.controls['PK_PERF'].value)
      };

      novaPermissao[permissao] = !novaPermissao[permissao];

      this.PermissoesList.push(novaPermissao);
    } else {
      this.PermissoesList[index][permissao] =
        !this.PermissoesList[index][permissao];
    }
  }

  getPermissoes(FK_PERF: number): void {
    this.isLoading = true;
    if (!FK_PERF) {
      this.isLoading = false;
      this.isBuscandoPermissoes = false;
      return;
    }

    this.permissaoService.GetPermissoes(FK_PERF).subscribe({
      next: (res: IGetPermissaoList) => {
        this.isLoading = false;
        this.isBuscandoPermissoes = false;
        if (!res.length) {
          this.isEditing = false;
          return;
        }
        this.isEditing = true;
        res.forEach(item => {
          this.addPermissoesNaLista(item);
        });
      },
      error: () => {
        this.isLoading = false;
        this.isBuscandoPermissoes = false;
      }
    });
  }

  getListaPermissoes(NU_TIPO_PERM: number): any[] | null {
    if (NU_TIPO_PERM >= 1 && NU_TIPO_PERM <= 5) return this.acessosData;
    if (NU_TIPO_PERM === 6) return this.agendamentoData;
    if ((NU_TIPO_PERM >= 7 && NU_TIPO_PERM <= 9) || NU_TIPO_PERM === 35) return this.parametrizacaoData;
    if (NU_TIPO_PERM === 10 || NU_TIPO_PERM === 85) return this.empresasData;
    if (NU_TIPO_PERM >= 11 && NU_TIPO_PERM <= 12) return this.gateDeEntradaData;
    if (NU_TIPO_PERM >= 13 && NU_TIPO_PERM <= 14) return this.servicosData;
    if (NU_TIPO_PERM >= 15 && NU_TIPO_PERM <= 16)
      return this.laudoHigienizacaoData;
    if (NU_TIPO_PERM >= 17 && NU_TIPO_PERM <= 19)
      return this.tampasGradesPaletesData;
    if (NU_TIPO_PERM >= 20 && NU_TIPO_PERM <= 21) return this.engateData;
    if (NU_TIPO_PERM >= 22 && NU_TIPO_PERM <= 23) return this.desengateData;
    if (NU_TIPO_PERM >= 24 && NU_TIPO_PERM <= 25) return this.gateSaidaData;
    if ((NU_TIPO_PERM >= 26 && NU_TIPO_PERM <= 28) || (NU_TIPO_PERM >= 33 && NU_TIPO_PERM <= 34) || NU_TIPO_PERM === 36) return this.caixaData;
    if (NU_TIPO_PERM === 29) return this.higienizacaoAgendadaData;
    if (NU_TIPO_PERM === 30) return this.logsData;
    if (NU_TIPO_PERM === 31) return this.motoristasExternoData;
    if (NU_TIPO_PERM === 37) return this.estoqueData;
    if (
      (NU_TIPO_PERM >= 40 && NU_TIPO_PERM <= 55) ||
      (NU_TIPO_PERM >= 57 && NU_TIPO_PERM <= 59) ||
      NU_TIPO_PERM === 79 ||
      NU_TIPO_PERM === 86
    ) {
      return this.relatoriosData;
    }
    if (
      NU_TIPO_PERM === 38 ||
      NU_TIPO_PERM === 39 ||
      NU_TIPO_PERM === 56 ||
      (NU_TIPO_PERM >= 60 && NU_TIPO_PERM <= 78) ||
      (NU_TIPO_PERM >= 80 && NU_TIPO_PERM <= 84)
    ) {
      return this.graficosData;
    }
    return null;
  }

  addPermissoesNaLista(item: IGetPermissao): void {
    const list = this.getListaPermissoes(item.NU_TIPO_PERM);
    if (!list) return;

    const dataItem = list.find(i => i.NU_TIPO_PERM === item.NU_TIPO_PERM);
    if (dataItem) {
      Object.keys(item).forEach(key => {
        if (typeof dataItem[key] === 'boolean')
          dataItem[key] = item[key as keyof IGetPermissao] ?? false;

        dataItem['PK_PERM'] = Number(item.PK_PERM);
      });
    }
  }

  getPerfis(): void {
    this.isLoading = true;
    this.perfilService.GetPerfis().subscribe({
      next: res => {
        this.perfisData = res.map(item => {
          return {
            name: item.NM_PERF,
            value: item.PK_PERF
          };
        });
        this.isLoading = false;
      },
      error: res => {
        this.isLoading = false;
      }
    });
  }

  onPerfilChange(event: number): void {
    if (this.isBuscandoPermissoes) return;
    this.isBuscandoPermissoes = true;
    this.form.controls['PK_PERF'].setValue(event);

    this.setPermission(false);
    this.getPermissoes(event);
  }

  onCheckAll(event: any) {
    const isChecked = event.target.checked;

    const checkboxes = document.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach((checkbox: any) => {
      if (checkbox.checked !== isChecked) {
        checkbox.click();

        checkbox.checked = isChecked;
      }
    });

    this.setPermission(isChecked);
  }

  setPermission(state: boolean): Promise<void> {
    return new Promise(resolve => {
      const dataLists = [
        this.acessosData,
        this.agendamentoData,
        this.parametrizacaoData,
        this.empresasData,
        this.gateDeEntradaData,
        this.gateSaidaData,
        this.servicosData,
        this.laudoHigienizacaoData,
        this.tampasGradesPaletesData,
        this.engateData,
        this.desengateData,
        this.caixaData,
        this.higienizacaoAgendadaData,
        this.logsData,
        this.motoristasExternoData,
        this.estoqueData,
        this.relatoriosData,
        this.graficosData
      ];

      dataLists.forEach(list => {
        list.forEach((item: any) => {
          Object.keys(item).forEach(key => {
            if (typeof item[key] === 'boolean') {
              item[key] = state;
            }
          });
        });
      });
      resolve();
    });
  }
}
